import { render, staticRenderFns } from "./MasterAwbupcoming.vue?vue&type=template&id=5880e25c&"
import script from "./MasterAwbupcoming.vue?vue&type=script&lang=js&"
export * from "./MasterAwbupcoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports